import Cards from 'react-credit-cards-2'
import { Button, HeaderCard, Label } from '~/design-system/primitives'
import { CreditCardOff, Delete } from '~/icons'
import { cn } from '~/lib/cn'

interface CardData {
  cardNumber: string
  expirationDate: string
  documentHolder: string
  accountId: string
}

interface CardDetailsProps {
  cardData: CardData
  cardHolder: string
  documentHolder: string
  verifyToDeleteCard: (accountId: string) => void
}

export default function CardDetails({
  cardData,
  cardHolder,
  documentHolder,
  verifyToDeleteCard,
}: CardDetailsProps) {
  return (
    <>
      <HeaderCard description={'Meus Cartões'} icon={<CreditCardOff />} />
      <div className="card-form-container flex flex-wrap md:py-5 flex-col xl:flex-row justify-items-stretch bg-white">
        <div className="card-container w-full mb-8 xl:w-2/6">
          <Cards
            cvc={''}
            expiry={cardData.expirationDate}
            focused={''}
            name={cardHolder}
            number={cardData.cardNumber}
          />
        </div>
        <div className="form-wrapper w-full xl:pl-4 xl:w-4/6 xl:mt-0">
          <div className="flex w-full gap-5 flex-col lg:w-6/6 lg:flex-row flex-wrap">
            <div className="flex w-full flex-col lg:flex-row gap-3">
              <div className="flex flex-col gap-1 w-full">
                <Label className="">Nome do titular *</Label>
                <input
                  className={cn(
                    'px-2 py-1.5 min-w-0 outline text-sm text-gray-800 text-primary-black max-h-9 border rounded bg-gray-20 outline-0',
                  )}
                  color="secondary"
                  id="name"
                  name="name"
                  type="text"
                  value={cardHolder}
                  readOnly
                />
              </div>
              <div className="flex flex-col gap-1 w-full">
                <Label className="">Número do cartão *</Label>
                <input
                  className={cn(
                    'px-2 py-1.5 min-w-0 outline text-sm text-gray-800 text-primary-black max-h-9 border rounded bg-gray-20 outline-0',
                  )}
                  id="name"
                  maxLength={245} //TODO: Everton comentou para isso ser revisado depois.
                  name="name"
                  type="text"
                  value={cardData.cardNumber}
                  readOnly
                />
              </div>
            </div>
            <div className="flex w-full flex-col lg:flex-row gap-3">
              <div className="flex flex-col gap-1 w-full">
                <Label className="">Vencimento *</Label>
                <input
                  className={cn(
                    'px-2 py-1.5 min-w-0 outline text-sm text-gray-800 text-primary-black max-h-9 border rounded bg-gray-20 outline-0',
                  )}
                  id="name"
                  name="name"
                  type="text"
                  value={cardData.expirationDate}
                  readOnly
                />
              </div>
              <div className="flex flex-col gap-1 w-full">
                <Label className="">CPF *</Label>
                <input
                  className={cn(
                    'px-2 py-1.5 min-w-0 outline text-sm text-gray-800 text-primary-black max-h-9 border rounded bg-gray-20 outline-0',
                  )}
                  id="name"
                  name="name"
                  type="text"
                  value={cardData.documentHolder}
                  readOnly
                />
              </div>
            </div>
          </div>
          <div className="flex flex-row justify-end w-full">
            <Button
              className="flex items-center mt-6 px-4 w-full lg:w-fit lg:justify-end justify-center py-2 gap-2 rounded border-2"
              hasIcon={true}
              isOutlined={true}
              onPress={() => verifyToDeleteCard(cardData.accountId)}
            >
              <Delete className="fill-gray-100 text-[20px]" />
              <span className="text-base">Excluir</span>
            </Button>
          </div>
        </div>
      </div>
    </>
  )
}
